import SecureLinkAnalyticsHeader from './SecureLinkAnalyticsHeader.component';

export default SecureLinkAnalyticsHeader;